module.exports = __webpack_public_path__ + "img/logo_white.442e5323.png";